
export const RadioModal = () => `
    <div id="radio-modal" class="settings-modal hidden">
        <div class="settings-content glass-panel radio-special-modal">
            <div class="settings-header">
                <h3><span class="icon">📻</span> GADDAR RADYO</h3>
                <button id="close-radio-btn" class="close-btn" title="Kapat">✖</button>
            </div>
            <div class="settings-body" style="padding: 0;">
                <iframe src="http://92.249.61.166:4005/?public=true" style="width:100%; height:100%; border:none; border-radius:16px; overflow:hidden;" allow="autoplay; microphone"></iframe>
            </div>
            <div class="settings-footer">
            </div>
        </div>
    </div>
`;
